import { Button } from "./ui/button";
import { Loader2, Download } from "lucide-react";

export const WebResults = ({ results, picked, setPicked, enrich, setEnrich, importing, onImport }) => {
  const list = results.businesses || [];
  const selectedCount = Object.values(picked).filter(Boolean).length;
  const allOn = list.length > 0 && selectedCount === list.length;
  const setAll = (v) => setPicked(Object.fromEntries(list.map((_, i) => [i, v])));

  return (
    <div className="mt-1" data-testid="web-import-results-panel">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs text-muted-foreground" data-testid="web-import-count">
          Found {results.count} business{results.count === 1 ? "" : "es"} · {selectedCount} selected
        </p>
        {list.length > 0 && (
          <button onClick={() => setAll(!allOn)} className="text-xs text-primary hover:underline" data-testid="web-import-toggle-all">
            {allOn ? "Select none" : "Select all"}
          </button>
        )}
      </div>
      <div className="max-h-64 overflow-y-auto rounded-lg border border-border divide-y divide-border" data-testid="web-import-results">
        {list.map((b, i) => (
          <label key={b.member_url || i} className="flex items-start gap-3 p-3 cursor-pointer hover:bg-secondary/40">
            <input type="checkbox" checked={!!picked[i]} onChange={(e) => setPicked({ ...picked, [i]: e.target.checked })}
              className="mt-1 accent-cyan-400" data-testid={`web-import-pick-${i}`} />
            <div className="min-w-0">
              <p className="font-medium text-sm truncate">{b.name}</p>
              <p className="text-xs text-muted-foreground truncate">
                {[b.phone, b.email, b.address].filter(Boolean).join(" · ") || "no contact details found"}
              </p>
              {b.category && <p className="text-xs text-muted-foreground/70 truncate">{b.category}</p>}
            </div>
          </label>
        ))}
      </div>
      {list.length > 0 && (
        <>
          <label className="flex items-center gap-2 mt-3 text-xs text-muted-foreground cursor-pointer">
            <input type="checkbox" checked={enrich} onChange={(e) => setEnrich(e.target.checked)}
              className="accent-cyan-400" data-testid="web-import-enrich" />
            Look up missing phone &amp; website on Google Maps after import
          </label>
          <Button onClick={onImport} disabled={importing || !selectedCount}
            className="w-full mt-3 bg-primary text-primary-foreground hover:bg-primary/90" data-testid="web-import-confirm">
            {importing ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Download className="h-4 w-4 mr-1.5" />}
            Import {selectedCount} lead{selectedCount === 1 ? "" : "s"}
          </Button>
        </>
      )}
    </div>
  );
};
